import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import moment from 'moment';
import { connect } from 'react-redux';

import { format } from '@breezeway/brzw-react-core';
import datastore from '@datastore';

import HistoryRowSections from './history_row_sections';
import Avatar from '../../avatar';
import { CATEGORIES, CLASS_NAME } from './constants';
import { DIFF_TIME_FORMAT } from '../../../utils/date_time';
import { getCategoryIcon } from './helpers';

import './history_row.scss';

const quotesWrapper = text => `"${text}"`;

export class HistoryRow extends HistoryRowSections {
  renderContent() {
    const { history } = this.props;
    const statusObject = _.get(history, 'context.status', null);
    const priorityObject = _.get(history, 'context.priority', null);
    const scheduleUpdates = _.get(history, 'context.schedule', null);

    return (
      <>
        {statusObject && HistoryRowSections.renderStatusObject(statusObject)}
        {priorityObject && HistoryRowSections.renderPriorityObject(priorityObject)}
        {scheduleUpdates && HistoryRowSections.renderScheduleUpdates(scheduleUpdates)}
      </>
    );
  }

  renderSubtext() {
    const { history } = this.props;
    const subtext = _.get(history, 'context.subtext', null);
    const category = _.get(history, 'context.event_category', null);
    const withQuotes = _.isEqual(category, CATEGORIES.COMMENT);

    return (
      subtext && (
        <div className={`${CLASS_NAME}__subtext`}>
          {withQuotes ? quotesWrapper(subtext) : subtext}
        </div>
      )
    );
  }

  renderFooter() {
    const { history, index } = this.props;
    const date = _.get(history, 'context.event_time');
    const identifier = `date-tooltip-${index}`;
    const formattedTime = format.datetime.formatDateTime(date, true, DIFF_TIME_FORMAT);
    const difference = moment().to(moment(formattedTime, DIFF_TIME_FORMAT));

    return (
      <div className={`${CLASS_NAME}__footer`}>
        <span id={identifier} className={`${CLASS_NAME}__date`}>
          {difference}
        </span>
        <UncontrolledTooltip
          autohide
          className={`${CLASS_NAME}__tooltip`}
          placement="bottom-start"
          target={identifier}
        >
          {formattedTime}
        </UncontrolledTooltip>
      </div>
    );
  }

  renderActionTitle() {
    const { history } = this.props;
    const textObject = _.get(history, 'context.text_object', null);
    const changeObject = _.get(history, 'context.change', null);

    if (textObject) return HistoryRowSections.renderTextObject(textObject);
    if (changeObject) return HistoryRowSections.renderChangeObject(changeObject);
    return null;
  }

  render() {
    const { history, getPersonFromId } = this.props;
    const actionText = _.get(history, 'context.action_text', '');
    const category = _.get(history, 'context.event_category', null);
    const type = _.get(history, 'context.event_type', null);
    const userName = _.get(history, 'context.action_by.full_name', null);
    const userId = _.get(history, 'context.action_by.id', null);
    const autoEvent = _.get(history, 'context.action_by.type') === 'auto';
    const breezewayEvent = _.get(history, 'context.action_by.type') === 'breezeway';
    const person = getPersonFromId(userId);

    return (
      <div className={CLASS_NAME}>
        <span
          className={classnames(
            `${CLASS_NAME}__category-icon`,
            `icon-${getCategoryIcon(category, type)}`,
          )}
        />
        <Avatar
          autoMessage={autoEvent}
          className={`${CLASS_NAME}__avatar`}
          icon={breezewayEvent ? 'breezeway' : null}
          name={userName}
          person={person}
          size="xxsmall"
        />
        <div className={`${CLASS_NAME}__content`}>
          <div className={`${CLASS_NAME}__title-section`}>
            <span className={`${CLASS_NAME}__text ${CLASS_NAME}__text--strong`}>{userName}</span>
            <span className={`${CLASS_NAME}__text`}>{` ${actionText} `}</span>
            {this.renderActionTitle()}
          </div>
          {this.renderContent()}
          {this.renderSubtext()}
          {this.renderFooter()}
        </div>
      </div>
    );
  }
}

HistoryRow.propTypes = {
  getPersonFromId: PropTypes.func,
  history: PropTypes.shape({}),
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const mapStateToProps = state => ({
  getPersonFromId: personId => datastore.selectors.company.getPerson(state, personId),
});

export default connect(mapStateToProps)(HistoryRow);
